import React, {Component} from 'react';
import './style.css';
import {Content, FormDescription, Header} from '../LoginForm/styles';
import {hideKioskWarning} from "../../reducers/kioskWarningReducer";
import {havePendingActionToConsider} from "../../reducers/userActivityReducer";
import connect from "react-redux/es/connect/connect";

class KioskInactivityWarning extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps.haveUserAction !== this.props.haveUserAction && this.props.haveUserAction) {
            this.props.hideKioskWarning();
        }
    }

    render() {
        return (
            <div className="kiosk-inactivity-warning-overlay">
                <div className="kiosk-inactivity-warning-wrapper">
                    <Content compact>
                        <Header>
                            <span>THANK YOU</span>
                        </Header>
                        <FormDescription>
                            Current session will be logged out due to inactivity
                        </FormDescription>
                    </Content>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    haveUserAction: havePendingActionToConsider(state)
});

const mapDispatchToProps = (dispatch) => ({
    hideKioskWarning: () => dispatch(hideKioskWarning())
});

export default connect(mapStateToProps, mapDispatchToProps)(KioskInactivityWarning);



// WEBPACK FOOTER //
// ./src/components/KioskInactivityWarning/KioskInactivityWarning.jsx